// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'

function switchPositionType(positionType) {
  if (positionType === 'left') {
    return 'right'
  } else if (positionType === 'right') {
    return 'left'
  }
  return ''
}

const IconComponent = styled.i`
  font-size: inherit;
  color: inherit;
  ${({ positionType }) =>
    positionType &&
    css`
    margin-${switchPositionType(positionType)}: 4px;
  `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
  ${({ fontSizeSp }) =>
    fontSizeSp &&
    css`
      font-size: ${fontSizeSp}px;
    `}
  ${({ fontSizePc }) =>
    fontSizePc &&
    css`
      ${mediaMin.phone`
      font-size: ${fontSizePc}px;
    `};
    `}
  ${({ padding }) =>
    padding &&
    css`
      padding: ${padding};
    `}
`

type PropTypes = {
  className?: string,
  type?: string,
  positionType?: 'left' | 'right',
  fontSizePc?: number,
  fontSizeSp?: number,
  color?: string,
  padding?: string,
}

export default function Icon(props: PropTypes) {
  return (
    <IconComponent
      className={
        props.className ? props.className : `fa fa-${props.type || ''}`
      }
      positionType={props.positionType}
      fontSizePc={props.fontSizePc}
      fontSizeSp={props.fontSizeSp}
      color={props.color}
      padding={props.padding}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/Icon/index.jsx